export default __webpack_public_path__ + "static/media/Apple-logo.976073ad.svg";